import { buildTimeConfig } from 'config'
import { LoginContainer } from 'modules/auth/components/LoginContainer/LoginContainer'
import { EnumSignupType } from 'modules/auth/types/signup'
import { Seo } from 'modules/common/components/Seo/Seo'
import LayoutLogin from 'modules/common/components/_layouts/LayoutLogin'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { EnumRoutes } from 'modules/common/routes'
import { BlankPage } from 'modules/common/types/page'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'

const ManagementOfferLoginPage: BlankPage = () => {
  const { t } = useTranslation('auth-page-login')

  const router = useRouter()

  if (!buildTimeConfig.signupConfig.canAccessManagementOffer) {
    router.replace(EnumRoutes.LOGIN)
  }

  return (
    <>
      <Seo
        title={t('meta.title')}
        description={t('meta.description')}
        noindex
      />
      <LoginContainer signupType={EnumSignupType.STRICTLY_MANAGEMENT_TOOLS} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [
      'auth-page-login',
      'auth-components',
      'common',
      'common-components',
    ])),
  },
})

ManagementOfferLoginPage.getLayout = (page) => (
  <LayoutLogin
    signupType={EnumSignupType.STRICTLY_MANAGEMENT_TOOLS}
    imagePath="/assets/img/login-screen-management-tools.png"
  >
    {page}
  </LayoutLogin>
)
ManagementOfferLoginPage.type = 'notAuthenticated'

export default ManagementOfferLoginPage
